import type { LocationManagerRoleEnum, UserResponse } from "@sidegigllc/api/client";

export const getRoleForLocation = (
  user: UserResponse | undefined,
  locationId: number,
): LocationManagerRoleEnum | undefined => user?.managed_locations.find((l) => l.location_id === locationId)?.role;

export const isOnsiteManager = (user: UserResponse | undefined, locationId: number): boolean =>
  getRoleForLocation(user, locationId) === "ONSITE_MANAGER";

export const homePathFor = (user: UserResponse, locationId: number): string =>
  isOnsiteManager(user, locationId) ? `/locations/${locationId}/schedule` : `/locations/${locationId}/home`;
